<template>
	<div class="marketing-section bg-color-content-primary">
		<div class="container col-10-xl mx-auto">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md pr-300-md display-flex flex-direction-column gap-100">
					<div class="label-sm text-transform-uppercase text-color-gray-20">Featured fund</div>
					<h2 class="heading-1 text-color-white">{{ props.data.title }}</h2>
					<p v-if="props.data.description" class="body-lg text-color-white mt-0">{{
						props.data.description
					}}</p>
					<FundKeyStats
						v-if="props.data.fundStats.length"
						:statistics="props.data.fundStats"
						theme="dark"
						class="my-50"
					/>
					<BaseCtaLink
						:link="props.data.ctaLink"
						classes="body-lg"
						:is-orange="true"
						:icon="appStore.isMobile ? '' : 'arrow'"
					/>
				</div>
				<div class="col-4-md pl-300-md mt-250 display-flex flex-direction-column gap-100">
					<div class="label-sm text-transform-uppercase text-color-gray-20">Asset types</div>
					<div
						v-for="(assetType, i) in props.data.assetTypes"
						:key="i"
						class="display-flex align-items-center gap-100 text-color-white"
					>
						<BaseSvgIcon :name="assetType.icon" width="24" height="24" />
						<span class="body-md">{{ assetType.label }}</span>
					</div>
				</div>
			</div>
			<InfoCardsInverted
				v-if="!!props.data.exampleAsset"
				:cards="[props.data.exampleAsset]"
				:hide-border="true"
				theme="dark"
				class="bg-color-gray-80 example-asset-card"
			/>
		</div>
	</div>
</template>
<script setup lang="ts">
import { FeaturedFundSectionData } from 'types/marketing-site';
import FundKeyStats from '@components/offering-details/fund-key-stats.vue';
import InfoCardsInverted from '@components/layout/info-cards-inverted.vue';
import { useAppStore } from '@stores/app';

interface Props {
	data: FeaturedFundSectionData;
}

const props = defineProps<Props>();

const appStore = useAppStore();
</script>
<style lang="scss" scoped>
.example-asset-card {
	border-radius: 8px;
	margin-top: 3.5rem;
}
</style>
